import React from 'react'
import { useState, useEffect, useRef } from 'react'
import { useTranslation } from 'react-i18next'

import styles from './style.module.scss'
import attachmentIcon from 'assets/images/toolbar-attachment.svg'
import FTIcon from 'components/FTIcon'
import closeIcon from 'assets/images/icon-close-20.svg'
import plusIcon from 'assets/images/plus-24.svg'

interface Attachment {
  filename: string
  mimeType: string
}

interface EditEventData {
  attachments: Attachment[]
}

interface AttachmentSelectorProps {
  editEventData: EditEventData
  onAddAttachment?: (file: File) => void
  onDeleteAttachment: (attachment: Attachment) => void
}

const AttachmentSelector: React.FC<AttachmentSelectorProps> = ({
  editEventData,
  onAddAttachment,
  onDeleteAttachment,
}) => {
  const [hasAttachment, setHasAttachment] = useState(editEventData.attachments.length > 0)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation()

  useEffect(() => {
    setHasAttachment(editEventData.attachments.length > 0)
  }, [editEventData])

  const pickFile = () => {
    fileInputRef.current?.click()
  }

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (files && files.length > 0) {
      // 파일 선택 후 처리 로직
      console.log('Selected files:', files)
      // onAddAttachment 콜백이 있다면 호출
      if (onAddAttachment) {
        for (const file of Array.from(files)) {
          onAddAttachment(file)
        }
      }
    }
    // 파일 input 초기화
    event.target.value = ''
  }

  return (
    <div className={styles.attachmentSelector}>
      <img src={attachmentIcon} alt="Attachment" className={styles.titleIcon} />
      {hasAttachment ? (
        <div className={styles.attachmentListContainer}>
          <div className={styles.attachmentList}>
            {editEventData.attachments.map((attachment) => (
              <div key={attachment.filename} className={styles.attachmentItem}>
                <div className={styles.attachmentInfo}>
                  <FTIcon fileName={attachment.filename} fileType={attachment.mimeType} size={24} />
                  <div className={styles.attachmentTitle}>{attachment.filename}</div>
                </div>
                <img
                  src={closeIcon}
                  alt="Close"
                  className={styles.attachmentCloseIcon}
                  onClick={() => onDeleteAttachment(attachment)}
                />
              </div>
            ))}
          </div>
          <div className={styles.attachmentAddButton} onClick={() => pickFile()}>
            <img src={plusIcon} alt="Attachment" />
          </div>
        </div>
      ) : (
        <div className={styles.attachmentHeader} onClick={() => pickFile()}>
          <div className={styles.attachmentTitle}>{t('editor.tooltip.attachment')}</div>
        </div>
      )}
      <input
        ref={fileInputRef}
        type="file"
        onChange={handleFileChange}
        className={styles.hiddenFileInput}
        accept="*/*"
      />
    </div>
  )
}

export default AttachmentSelector
